<template>
  <div  class="ds-control dsf-sc-table-design dsf-sc-biaotou" :class="getCss" @click="click">
    <img :src="'./static/img/project/tableDesign/biaotoutupian.jpg'" />
  </div>
</template>
 
<script>
export default dsf.component({
  name: "DsfSCBiaotou",
  ctrlCaption: "表头",
   mixins: [$mixins.control],
  props: {
    // 表名
    bm: {
      type: Boolean,
      default: true,
    },
    // 表号
    bh: {
      type: Boolean,
      default: true,
    },
    // 制定单位
    zddw: {
      type: Boolean,
      default: true,
    },
    // 文号
    wh: {
      type: Boolean,
      default: true,
    },
    // 有效期
    yxq: {
      type: Boolean,
      default: true,
    },
    // 统一社会信用代码
    tyshxydm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    click() {
      dsf.layer.openDialog()
    },
  },
});
</script>

<style></style>
